// deployment_class: customer_env_allowed
/**
 * LandingRedirect — Layer B wired at `/` (Role-View spec §2). Resolves the
 * authenticated actor's home from the landing map and either renders the cockpit
 * in place or redirects to the role's home.
 *
 * Rendered INSIDE `RequireAuthGate` (App.tsx), so the session is already
 * resolved; the `status`/`user` guard is defence-in-depth (never redirect
 * mid-bootstrap). Dashboard-home roles (CEO tier + staff/advisory) render
 * {@link DashboardHome} IN PLACE — no redirect, no flash — so the CEO-first
 * demo experience is byte-identical to before this layer existed. Every other
 * role is sent to its home via a replace-navigation.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { DashboardHome } from '../DashboardHome';
import { homeRouteFor } from './landing-map';

export function LandingRedirect(): JSX.Element {
  const { user, status } = useAuth();

  // Defence-in-depth: never resolve a landing until the session is concrete.
  if (status !== 'authenticated' || !user) {
    return <div className="p-page" aria-busy="true" />;
  }

  const home = homeRouteFor(user.role);
  // Dashboard-home roles render the cockpit in place (no redirect).
  if (home === '/') return <DashboardHome />;
  return <Navigate to={home} replace />;
}
